import React, { useEffect, useState } from 'react'
import { HttpService, API, Title } from '../../config/react'
import { Link } from 'react-router-dom'
const LinkStatistics = () => {
  const [Products, setProducts] = useState([])
  const [Categories, setCategories] = useState([])
  const [Pages, setPages] = useState([])

  useEffect(() => {
    GetLinkStatistics()
  }, [])

  const GetLinkStatistics = () => {
    HttpService.getApi(API.GetLinkStatistics).then((response) => {
      // console.log(response.data.result)
      if (response.data.status && response.data.result[0].length > 0) {
        setProducts(response.data.result[0].filter((item) => item.type === 'products'))
        setCategories(response.data.result[0].filter((item) => item.type === 'category'))
        setPages(response.data.result[0].filter((item) => item.type === 'pages'))
      }
    })
  }

  return (
    <div className="content-wrapper pb-0">
      <div className="page-header">
        <h3 className="page-title"> {Title.LinkStatistics} </h3>
      </div>
      <div className="row">
        <div className="col-md-6 col-lg-4 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <div className="w-100">
                <div className="card-header p-0 mb-3">
                  <h3 className="title font-20">{Title.Products}</h3>
                </div>
                <table className="table table-striped table-borderless">
                  <tbody>
                    <tr>
                      <th className="w-75">Headline</th>
                      <th>Clicks</th>
                    </tr>
                    {Products.length > 0 ? (
                      Products.map((item, index) => (
                        <tr key={index}>
                          <td className="w-75">
                            <Link
                              to={{ pathname: process.env.REACT_APP_FRONTEND_URL + item.URL }}
                              target="_blank"
                            >
                              {item.label}
                            </Link>
                          </td>
                          <td>{item.clicks}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td
                          className="text-center"
                          colSpan="2"
                        >
                          No data available
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-6 col-lg-4 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <div className="w-100">
                <div className="card-header p-0 mb-3">
                  <h3 className="title font-20">{Title.Category}</h3>
                </div>
                <table className="table table-striped table-borderless">
                  <tbody>
                    <tr>
                      <th className="w-75">Headline</th>
                      <th>Clicks</th>
                    </tr>
                    {Categories.length > 0 ? (
                      Categories.map((item, index) => (
                        <tr key={index}>
                          <td className="w-75">
                            <Link
                              to={{ pathname: process.env.REACT_APP_FRONTEND_URL + item.URL }}
                              target="_blank"
                            >
                              {item.label}
                            </Link>
                          </td>
                          <td>{item.clicks}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td
                          className="text-center"
                          colSpan="2"
                        >
                          No data available
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-6 col-lg-4 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <div className="w-100">
                <div className="card-header p-0 mb-3">
                  <h3 className="title font-20">{Title.Pages}</h3>
                </div>
                <table className="table table-striped table-borderless">
                  <tbody>
                    <tr>
                      <th className="w-75">Headline</th>
                      <th>Clicks</th>
                    </tr>
                    {Pages.length > 0 ? (
                      Pages.map((item, index) => (
                        <tr key={index}>
                          <td className="w-75">
                            <Link
                              to={{ pathname: process.env.REACT_APP_FRONTEND_URL + item.URL }}
                              target="_blank"
                            >
                              {item.label}
                            </Link>
                          </td>
                          <td>{item.clicks}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td
                          className="text-center"
                          colSpan="2"
                        >
                          No data available
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default LinkStatistics
